'use strict';

/**
 *
 * @name: ddCredits
 *
 */

import DirectiveTemplate from './nn-dropdown-credits.directive.html';

function DdCreditsDirective($rootScope) {

  'ngInject';

  return {
    replace: true,
    template: DirectiveTemplate,
    scope: {
      post: '=',
      showCredits: '=',
      toggleDd: '='
    },
    link: function(scope, element) {

      var creditsGoCompile = $rootScope.$on('goCompile', function() {

        setTimeout(function() {

          scope.$apply();
        }, 1);
      });

      var watchShowCredits = scope.$watch('showCredits', function(newVal) {

        if (newVal === true) {

          $(element).slideDown(250);
        } else {

          $(element).slideUp(250);
        }
      });

      scope.$on('destroy', function() {

        creditsGoCompile();
        watchShowCredits();
        element.find('*').remove();
      });
    }
  };
}

export default DdCreditsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-dropdown-credits/nn-dropdown-credits.directive.js